'use client';
import { useStores } from '@/models';
import { Slider, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { buildSearchUrl, formatInteger } from '../../util';
import styles from './index.module.scss';
import JDIPrice from '@/components/price/index';

const PSlider = styled(Slider)({
  color: '#1A1A1A', // 主色调
  '& .MuiSlider-thumb': {
    backgroundColor: '#ffffff', // 滑块的颜色
    border: '3px solid #1A1A1A',
    boxShadow: 'none !important',
    transition: 'all 0.2s ease-out', // 添加过渡效果
    '&.Mui-active': {
      boxShadow: 'none',
      width: 20, // 拖动时放大尺寸
      height: 20,
      transform: 'translate(-50%, -50%) scale(1.2)', // 使用scale实现更流畅的放大
    },
  },
  '& .MuiSlider-track': {
    backgroundColor: '#1A1A1A;', // 已拖动部分轨道颜色
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#E1E3E6',
  },
});

interface PriceSliderProps {
  onSearch: () => void;
  baseUrl?: string;
  localInfo: any;
}

const PriceSlider = observer(({ onSearch, baseUrl, localInfo = {} }: PriceSliderProps) => {
  const { searchStore } = useStores();

  // 拖动的时候修改store
  const handleChange = (l: number, r: number) => {
    searchStore.setSelectedMinPrice(l);
    searchStore.setSelectedMaxPrice(r);
  };
  // 真正松手的时候才去请求接口
  const handleSearch = () => {
    const searchUrl = buildSearchUrl(searchStore.searchParams, baseUrl);
    window.history.pushState(null, '', searchUrl);
    onSearch && onSearch();
  };

  return (
    <div className={styles.priceSlider}>
      <span className={`${styles.currPrice}`}>
        <JDIPrice
          locale={localInfo?.languageCode}
          currency={localInfo?.currency}
          price={`${searchStore.selectedMinPrice}`}
          containerStyle={{
            color: '#1a1a1a',
            fontSize: '14px',
            fontWeight: 400,
          }}
          symbolStyle={{ fontSize: '14px' }}
          integerStyle={{ fontSize: '14px' }}
          decimalPointStyle={{ fontSize: '14px' }}
          decimalPlaceStyle={{ fontSize: '14px' }}
          minimumFractionDigits={0}
          maximumFractionDigits={0}
        />
        &nbsp;-&nbsp;
        <JDIPrice
          locale={localInfo?.languageCode}
          currency={localInfo?.currency}
          price={`${searchStore.selectedMaxPrice}`}
          containerStyle={{
            color: '#1a1a1a',
            fontSize: '14px',
            fontWeight: 400,
          }}
          symbolStyle={{ fontSize: '14px' }}
          integerStyle={{ fontSize: '14px' }}
          decimalPointStyle={{ fontSize: '14px' }}
          decimalPlaceStyle={{ fontSize: '14px' }}
          minimumFractionDigits={0}
          maximumFractionDigits={0}
        />
      </span>
      <PSlider
        min={Number(searchStore.minPrice)}
        max={Number(searchStore.maxPrice)}
        valueLabelDisplay='off'
        value={[Number(searchStore.selectedMinPrice), Number(searchStore.selectedMaxPrice)]}
        onChange={(event, v) => {
          const [l, r] = v as number[];
          handleChange(l, r);
        }}
        onChangeCommitted={() => {
          handleSearch();
        }}
      />
    </div>
  );
});

export default PriceSlider;
